import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';

@Injectable({
  providedIn: 'root'
})
export class ReporteAvanceDeComisionesIndividualesService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.reporteAvanceDeComisionesIndividuales;
  }

  getTodo() {

    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;

    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo + "anio=" + year + "&mes=" + month);
  }

}
